import type { ReactNode } from 'react';

/** 卡片标题行：左标题（原生 `.headline`），右侧可带说明或操作（原生的「近 7 天 ›」位置）。 */
export function SectionHeader({ title, trailing }: { title: ReactNode; trailing?: ReactNode }) {
  return (
    <div className="flex min-h-6 items-center justify-between gap-3">
      <h2 className="text-callout font-semibold ios:text-body">{title}</h2>
      {trailing != null ? (
        <div className="text-muted-foreground shrink-0 text-footnote tabular-nums ios:text-subheadline">{trailing}</div>
      ) : null}
    </div>
  );
}
